import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

const pillStyles = cva(
  [
    "inline-flex items-center gap-1.5 whitespace-nowrap",
    "text-[10px] font-semibold tracking-[0.06em] uppercase",
    "px-2.5 py-1 rounded-full border",
  ].join(" "),
  {
    variants: {
      tone: {
        ok: "bg-profit/10 text-profit border-profit/30",
        warn: "bg-amber/11 text-amber border-amber/35",
        bad: "bg-loss/10 text-loss border-loss/30",
        info: "bg-surface-raised text-ink-muted border-stroke-strong",
        amber: "bg-amber-dim text-amber border-amber/35",
      },
    },
    defaultVariants: {
      tone: "info",
    },
  },
);

type PillProps = HTMLAttributes<HTMLSpanElement> & VariantProps<typeof pillStyles>;

export function Pill({ className, tone, children, ...props }: PillProps) {
  return (
    <span className={cn(pillStyles({ tone }), className)} {...props}>
      {children}
    </span>
  );
}
